export const resolveImageUrl = (imagePath) => {
  if (!imagePath || typeof imagePath !== "string") {
    return "";
  }

  const sanitizedPath = imagePath.trim();
  if (!sanitizedPath) {
    return "";
  }

  if (/^https?:\/\//i.test(sanitizedPath)) {
    return sanitizedPath;
  }

  if (sanitizedPath.startsWith("storage.googleapis.com/")) {
    return `https://${sanitizedPath}`;
  }

  const bucket = (import.meta.env.VITE_GCS_BUCKET || "").trim();
  if (!bucket) {
    return sanitizedPath;
  }

  return `https://storage.googleapis.com/${bucket}/${sanitizedPath.replace(/^\/+/, "")}`;
};
